import {gql} from '@apollo/client';


export const GET_CUSTOMER_LIST = gql`
    query CustomerList{
        customerList{
            id
            displayName
        }
    }
`;

export const GET_CAR_LIST = gql`
    query CarList{
        carList{
            id
            createInvoiceDisplayName
        }
    }
`;

export const GET_PAGINATED_CAR_LIST = gql`
    query carListPaginated($page: Int!, $perPage: Int!, $search: String!) {
        carListPaginated(page: $page, perPage: $perPage, search: $search) {
            data {
                id
                createInvoiceDisplayName
            }
            paginator {
                numPages
                currentPage
            }
        }
    }
`;

export const GET_PAGINATED_CAR_PART_LIST = gql`
    query getCarPartsPaginated($page: Int!, $perPage: Int!, $search: String!) {
        getCarPartsPaginated(page: $page, perPage: $perPage, search: $search) {
            data {
                id
                name
            }
            paginator {
                numPages
                currentPage
            }
        }
    }
`;

export const CREATE_INDEPENDENT_INVOICE = gql`
    mutation CreateIndependentInvoice($invoice: CreateIndependentInvoiceInput!, $workshopId: String!){
        createIndependentInvoiceV2(invoice: $invoice, workshopId: $workshopId){
            success
        }
    }
`;

export const GET_WORKSHOP_LIST = gql`
    query workshopList($workshopGroupId: String, $includeVendor: Boolean) {
        workshopList(workshopGroupId: $workshopGroupId, includeVendor: $includeVendor){
            id
            name
            displayName
        }
    }
`;

export const GET_MICRO_PARTS_TAX_CODES = gql`
    query MicroPartsTaxCodes{
        microParts:getCarParts{
            id
            name
        }
        fix:getAllFixes{
            id
            name
        }
        taxCodes:getTaxCodes{
            id
            code
            type
        }
    }
`;